import { IUser } from '@app/core/models/user';
import { IResetPasswordPayload } from '@app/reset-password/models/reset-password';

export enum SessionActionType {
  Login = '[Session] Login',
  RefreshToken = '[Session] Refresh Token',
  FetchLoggedInUser = '[Session] FetchLoggedInUser',
  Logout = '[Session] Logout',
  SetToken = '[Session] SetToken',
  SetUser = '[Session] SetUser',
  ResetPassword = '[Session] ResetPassword',
  SendResetPasswordLink = '[Session] SendResetPasswordLink',

  SetRememberMe = '[Session] SetRememberMe',
  SetLastLoginUsername = '[Session] SetLastLoginUsername',
}

export class Login {
  static readonly type = SessionActionType.Login;
  constructor(public username: string, public password: string) {}
}

export class RefreshToken {
  static readonly type = SessionActionType.RefreshToken;
  constructor(public token: string) {}
}

export class FetchLoggedInUser {
  static readonly type = SessionActionType.FetchLoggedInUser;
}

export class Logout {
  static readonly type = SessionActionType.Logout;
}

export class SetToken {
  static readonly type = SessionActionType.SetToken;
  constructor(public token: string, public refresh_token?: string) {}
}

export class SetUser {
  static readonly type = SessionActionType.SetUser;
  constructor(public user: IUser) {}
}

export class ResetPassword {
  static readonly type = SessionActionType.ResetPassword;
  constructor(public payload: IResetPasswordPayload) {}
}

export class SendResetPasswordLink {
  static readonly type = SessionActionType.SendResetPasswordLink;
  constructor(public email: string) {}
}

export class SetRememberMe {
  static readonly type = SessionActionType.SetRememberMe;
  constructor(public rememberMe: boolean) {}
}

export class SetLastLoginUsername {
  static readonly type = SessionActionType.SetLastLoginUsername;
  constructor(public lastUsername: string) {}
}
